import useDateFormatters from "@hooks/useDateFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { SeriesDateBadgeProps } from "./SeriesDateBadge.types"

// Custom kit icons: a calendar with a play badge (start) and a calendar with a ban badge (end).
const startIcon = faIcon({ name: "regular-calendar-circle-play", style: "kit" })
const endIcon = faIcon({ name: "regular-calendar-ban", style: "kit" })

export default function SeriesDateBadge(props: SeriesDateBadgeProps) {
    const { date, variant, size = "md" } = props

    const { formatDate } = useDateFormatters()

    const icon = variant === "start" ? startIcon : endIcon
    const label = variant === "start" ? "Series start" : "Series end"

    if (variant === "end" && !date) {
        return (
            <Badge size={size} variant="icon" icon={icon} tooltip={`${label}\nNo end date`}>
                No end date
            </Badge>
        )
    }

    const formatted = formatDate(date)
    // e.g. "Series start\nJanuary 1, 2025".
    const tooltip = `${label}\n${formatDate(date, "long")}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {formatted}
        </Badge>
    )
}
